import { render, staticRenderFns } from "./tags-modal.vue?vue&type=template&id=3c799562&scoped=true"
import script from "./tags-modal.vue?vue&type=script&lang=ts"
export * from "./tags-modal.vue?vue&type=script&lang=ts"
import style0 from "./tags-modal.vue?vue&type=style&index=0&id=3c799562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c799562",
  null
  
)

export default component.exports